import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Header from "../../../Components/adminDashboard/Header/Header";
import "../CatagoryManagment/AdminNew.scss";
import uploadIcon from "../../../assets/images/upload_icon_blue.svg";
import Swal from "sweetalert2";
import combinedServices from "../../../shared/services/user-service";
import getLocalData from "../../../shared/localStorage/getData";

const Editstore = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [districts, setDistricts] = useState([]);
  const [users, setUsers] = useState([]);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [showDropdown, setShowDropdown] = useState(false);
  const [adminid, setAdminid] = useState();
  const [formData, setFormData] = useState({
    store_name: "",
    storeimages: [],
    created_by: "",
    districts: [],
    store_admins: [],
    published: false,
    open_date: "",
    close_date: ""
  });
  const [uploadedImages, setUploadedImages] = useState([]);
  const [originalStoreData, setOriginalStoreData] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const districtsResponse = await combinedServices.getAllDistric();
        if (districtsResponse && districtsResponse.data) {
          setDistricts(districtsResponse.data);
        }

        const usersResponse = await combinedServices.getAllUserNames();
        if (usersResponse && usersResponse.data) {
          setUsers(usersResponse.data);
          setFilteredUsers(usersResponse.data);
        }

        if (getLocalData("admin_info", "isLogin")) {
          let adminId = getLocalData("admin_info", "all").userData.user.id;
          setAdminid(adminId);
        }

        if (id) {
          const storeResponse = await combinedServices.getstorebyid(id);
          console.log("Store Response:", storeResponse);
          if (storeResponse && storeResponse.data && storeResponse.data.data) {
            const store = storeResponse.data.data;

            // Parse JSON fields if they are strings
            const storeImages =
              typeof store.storeimage === "string"
                ? JSON.parse(store.storeimage)
                : store.storeimage || [];

            const storeDistricts =
              typeof store.district === "string"
                ? JSON.parse(store.district)
                : store.district || [];

            const storeAdmins =
              typeof store.storeadmins === "string"
                ? JSON.parse(store.storeadmins)
                : store.storeadmins || [];

            setOriginalStoreData(store);
            setUploadedImages(storeImages);

            const formatDateForInput = (isoDate) => {
              if (!isoDate) return "";
              const date = new Date(isoDate);
              return date.toISOString().split("T")[0];
            };

            setFormData({
              store_name: store.storename || "",
              storeimages: storeImages,
              created_by: store.created_by || "",
              districts: storeDistricts,
              store_admins: storeAdmins.map((admin) => ({
                id: admin.id,
                firstname: admin.firstname,
                lastname: admin.lastname
              })),
              published: store.isAvailable || false,
              open_date: formatDateForInput(store.openDate),
              close_date: formatDateForInput(store.closeDate)
            });
          }
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Failed to load store data. Please try again."
        }).then(() => {
          navigate("/storelist");
        });
      }
    };

    fetchData();
  }, [id, navigate]);

  useEffect(() => {
    if (searchTerm.trim() === "") {
      setFilteredUsers(users);
    } else {
      const filtered = users.filter(
        (user) =>
          `${user.user_firstname} ${user.user_lastname}`
            .toLowerCase()
            .includes(searchTerm.toLowerCase()) ||
          user.user_email.toLowerCase().includes(searchTerm.toLowerCase())
      );
      setFilteredUsers(filtered);
    }
  }, [searchTerm, users]);

  const handleAdminSelect = (user) => {
    if (!formData.store_admins.some((admin) => admin.id == user.id)) {
      setFormData((prev) => ({
        ...prev,
        store_admins: [
          ...prev.store_admins,
          {
            id: user.id,
            firstname: user.user_firstname,
            lastname: user.user_lastname
          }
        ]
      }));
    }
    setSearchTerm("");
    setShowDropdown(false);
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value
    }));
  };

  const handleDistrictSelect = (e) => {
    const districtId = e.target.value;
    if (districtId && !formData.districts.includes(districtId)) {
      setFormData((prev) => ({
        ...prev,
        districts: [...prev.districts, districtId]
      }));
    }
  };

  const removeDistrict = (districtIdToRemove) => {
    setFormData((prev) => ({
      ...prev,
      districts: prev.districts.filter((id) => id !== districtIdToRemove)
    }));
  };

  const removeAdmin = (adminIdToRemove) => {
    setFormData((prev) => ({
      ...prev,
      store_admins: prev.store_admins.filter(
        (admin) => admin.id !== adminIdToRemove
      )
    }));
  };

  const handleFileChange = async (e) => {
    const files = e.target.files;
    const newImages = [...uploadedImages];
    const maxSize = 2 * 1024 * 1024;
    const allowedTypes = ["image/jpeg", "image/png"];

    if (uploadedImages.length >= 2) {
      Swal.fire({
        icon: "warning",
        title: "Maximum Images Reached",
        text: "You cannot upload more than 2 images."
      });
      return;
    }

    for (let i = 0; i < files.length; i++) {
      const file = files[i];

      if (!allowedTypes.includes(file.type)) {
        alert("Only JPG and PNG images are allowed.");
        continue;
      }

      if (file.size > maxSize) {
        alert("File size must be less than 2 MB.");
        continue;
      }

      if (newImages.length >= 2) {
        Swal.fire({
          icon: "warning",
          title: "Maximum Images Reached",
          text: "You cannot upload more than 2 images."
        });
        break;
      }

      const formData = new FormData();
      formData.append("image", file);

      try {
        const uploadResponse = await combinedServices.uploadImageFromAdmin(
          formData
        );

        if (uploadResponse.status === 200) {
          const imageUrl = uploadResponse.data.location;
          newImages.push(imageUrl);
        } else {
          alert("Failed to upload image. Please try again.");
        }
      } catch (error) {
        console.error("Error uploading image:", error);
        alert("An error occurred while uploading the image.");
      }
    }

    setUploadedImages(newImages);
  };

  const removeImage = (imageToRemove) => {
    const filteredImages = uploadedImages.filter(
      (image) => image !== imageToRemove
    );
    setUploadedImages(filteredImages);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.store_name.trim()) {
      Swal.fire({
        icon: "warning",
        title: "Validation Error",
        text: "Store Name cannot be empty."
      });
      return;
    }

    if (formData.store_name.length > 100) {
      Swal.fire({
        icon: "warning",
        title: "Validation Error",
        text: "Store Name cannot exceed 100 Characters."
      });
      return;
    }

    if (formData.districts.length === 0) {
      Swal.fire({
        icon: "warning",
        title: "Validation Error",
        text: "Please select at least one district."
      });
      return;
    }

    if (formData.store_admins.length === 0) {
      Swal.fire({
        icon: "warning",
        title: "Validation Error",
        text: "Please select at least one store admin."
      });
      return;
    }

    if (uploadedImages.length === 0 || uploadedImages.length > 2) {
      Swal.fire({
        icon: "warning",
        title: "Validation Error",
        text: "Please upload 1-2 store images."
      });
      return;
    }

    if (!formData.open_date) {
      Swal.fire({
        icon: "warning",
        title: "Validation Error",
        text: "Please select an Open Date."
      });
      return;
    }

    if (!formData.close_date) {
      Swal.fire({
        icon: "warning",
        title: "Validation Error",
        text: "Please select a Close Date."
      });
      return;
    }

    if (new Date(formData.close_date) <= new Date(formData.open_date)) {
      Swal.fire({
        icon: "warning",
        title: "Validation Error",
        text: "Close Date must be after Open Date."
      });
      return;
    }

    const formDataToSubmit = {
      ...formData,
      id: id,
      storeimages: uploadedImages,
      created_by: adminid
    };

    try {
      let response;
      if (id) {
        response = await combinedServices.updatestore(formDataToSubmit);
      } else {
        response = await combinedServices.createstore(formDataToSubmit);
      }

      if (
        response &&
        (response.data.status === 200 || response.data.status === 201)
      ) {
        Swal.fire({
          icon: "success",
          title: id ? "Store Updated" : "Store Added",
          text: response.data.message
        }).then(() => {
          navigate("/storelist");
        });
      } else {
        throw new Error(response.data.error || "Failed to update store");
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.message || "There was an error updating the store."
      });
    }
  };

  return (
    <>
      <Header />
      <div className="dbAdminRight newDbRight">
        <div className="dbMid dbInner">
          <div className="dbMainHd">{id ? "Edit Store" : "Add Store"}</div>
          <div className="whtBoxWrpOuter">
            <form onSubmit={handleSubmit}>
              <div className="whtBoxWrpper">
                {/* left box starts here */}
                <div className="wbx_Cont wbx_left">
                  <div className="form_grpWrp">
                    <label htmlFor="store_name">
                      Store Name <span className="req">*</span>
                    </label>
                    <div className="form_grp">
                      <input
                        type="text"
                        id="store_name"
                        name="store_name"
                        value={formData.store_name}
                        onChange={handleChange}
                        className="form_ctrl"
                        placeholder="Enter Store Name"
                        maxLength="100"
                      />
                      <span className="errormsg">
                        Do not exceed 100 Characters when entering the store
                        name.
                      </span>
                    </div>
                  </div>

                  <div className="form_grpWrp">
                    <label htmlFor="districts">
                      Districts <span className="req">*</span>
                    </label>
                    <div className="form_grp">
                      <select
                        id="districts"
                        name="districts"
                        onChange={handleDistrictSelect}
                        className="form_ctrl cusSel"
                        value=""
                      >
                        <option value="">Select District</option>
                        {districts.map((district) => (
                          <option
                            key={district.id}
                            value={district.district_id}
                            disabled={formData.districts.includes(
                              district.district_id
                            )}
                          >
                            {district.name} D{district.district_id}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="entered-values">
                      {formData.districts.map((districtId) => {
                        const district = districts.find(
                          (d) => d.district_id === districtId
                        );
                        return (
                          <div key={districtId} className="value-tag">
                            {district
                              ? `${district.name} (D${district.district_id})`
                              : districtId}
                            <span
                              className="remove-icon"
                              onClick={() => removeDistrict(districtId)}
                            >
                              &times;
                            </span>
                          </div>
                        );
                      })}
                    </div>
                  </div>

                  <div className="form_grpWrp">
                    <label>
                      Store Admins <span className="req">*</span>
                    </label>
                    <div className="form_grp position-relative">
                      <input
                        type="text"
                        className="form_ctrl"
                        placeholder="Search by name or email"
                        value={searchTerm}
                        onChange={(e) => {
                          setSearchTerm(e.target.value);
                          setShowDropdown(true);
                        }}
                        onFocus={() => setShowDropdown(true)}
                      />
                      {showDropdown && (
                        <div className="dropdown-menu show w-100 custom-dropdown">
                          <div className="dropdown-content-container">
                            {filteredUsers.length > 0 ? (
                              filteredUsers.map((user) => (
                                <button
                                  key={user.id}
                                  type="button"
                                  className="dropdown-item user-option"
                                  onClick={() => handleAdminSelect(user)}
                                  disabled={formData.store_admins.some(
                                    (admin) => admin.id == user.id
                                  )}
                                >
                                  <span className="user-name">
                                    {user.user_firstname} {user.user_lastname}
                                  </span>{" "}
                                  &nbsp;
                                  <span className="user-email text-muted">
                                    ({user.user_email})
                                  </span>
                                </button>
                              ))
                            ) : (
                              <div className="dropdown-item no-results">
                                No users found
                              </div>
                            )}
                          </div>
                        </div>
                      )}
                    </div>
                    <div className="entered-values">
                      {formData.store_admins.map((admin) => (
                        <div key={admin.id} className="value-tag">
                          {admin.firstname} {admin.lastname}
                          <span
                            className="remove-icon"
                            onClick={() => removeAdmin(admin.id)}
                          >
                            &times;
                          </span>
                        </div>
                      ))}
                    </div>
                  </div>

                  <div className="form_grpWrp">
                    <label htmlFor="open_date">
                      Open Date <span className="req">*</span>
                    </label>
                    <div className="form_grp">
                      <input
                        type="date"
                        id="open_date"
                        name="open_date"
                        value={formData.open_date}
                        onChange={handleChange}
                        className="form_ctrl"
                      />
                    </div>
                  </div>

                  <div className="form_grpWrp">
                    <label htmlFor="close_date">
                      Close Date <span className="req">*</span>
                    </label>
                    <div className="form_grp">
                      <input
                        type="date"
                        id="close_date"
                        name="close_date"
                        value={formData.close_date}
                        onChange={handleChange}
                        className="form_ctrl"
                        min={formData.open_date}
                      />
                    </div>
                  </div>
                </div>

                {/* right box starts here */}
                <div className="wbx_Cont wbx_right">
                  <div className="form_grpWrp">
                    <label htmlFor="selectField">Upload Images (1-2)</label>
                    <div className="upldCont">
                      <div className="custom-file-input-container form_grp cusImgUpld">
                        <label className="custom-file-label">
                          <input
                            type="file"
                            multiple
                            onChange={handleFileChange}
                            className="custom-file-input"
                          />
                          <div className="custom-file-button">
                            <img src={uploadIcon} alt="upload icon" />
                            <p>
                              Drop your images here or select{" "}
                              <span>click to browse</span>
                            </p>
                          </div>
                        </label>
                      </div>

                      {/* Display uploaded images */}
                      {uploadedImages.map((image, index) => (
                        <div key={index} className="uploaded-images-container">
                          <div className="uploadedImgW">
                            <img src={image} alt="uploaded" />
                            <span
                              className="remove-icon-image"
                              onClick={() => removeImage(image)}
                            >
                              &times;
                            </span>
                          </div>
                        </div>
                      ))}
                      <span className="errormsg">
                        <p style={{ color: "red" }}>
                          Recommended resolution: 1080 x 1080 px
                        </p>
                        You can upload 1-2 images. Pay attention to the quality.
                      </span>
                    </div>
                  </div>

                  <div className="form_grpWrp">
                    <label>
                      <input
                        type="checkbox"
                        name="published"
                        checked={formData.published}
                        onChange={handleChange}
                        className="form_checkbox"
                      />
                      Published
                    </label>
                  </div>
                  <div className="productBtnWrp">
                    <button type="submit" className="BtnB blB">
                      {id ? "UPDATE STORE" : "ADD STORE"}
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default Editstore;
